import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { LuUsers } from "react-icons/lu";

import { Skeleton } from "@/components/ui/skeleton/skeleton";
import { getAllAllowanceRequestsQueryOptions } from "@/config/queries/query-options";

export const AllowancesCard = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending } = useQuery(
    getAllAllowanceRequestsQueryOptions(user, "Pending")
  );

  return (
    <>
      {isPending ? (
        <Skeleton className="w-40 h-20"></Skeleton>
      ) : (
        <div className="w-64 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border">
          <div className="flex flex-row items-center p-6 pb-2 justify-between">
            <h2 className="text-sm font-medium">Pending Allowance Requests</h2>

            <LuUsers className="w-3 h-3" />
          </div>
          <div className="p-6 pt-0">
            <div className="text-2xl font-bold">
              {data?.Allowances?.length || 0}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
